
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Anclar',
	'find_label': 'Buscar',
	'findCancelLabel': 'Cancelar',
	'dataPaneLabel': 'Datos',
	'sourcePaneLabel': 'Orígenes seleccionados',
	'sourcePaneContentLabel': 'Seleccionar un origen',
	'emptySourcePaneTitle': 'Seleccionar un origen',
	'emptySourcePaneCaption': 'Pulse Seleccionar un origen para añadir datos para crear un panel de control.',
	'addDataSource': 'Seleccionar un origen',
	'addDataDashboardCoachMarkContents': 'Arrastre los datos del panel de datos y suéltelos en el panel de control.',
	'addDataStoryCoachMarkContents': 'Arrastre los datos del panel de datos y suéltelos en la historia.',
	'addDataCoachMarkTitle': 'Añadir datos',
	'selectSourcesText': 'Seleccione y añada un origen de datos para crear su %{app}.',
	'selectSourcesLabel': 'Seleccionar un origen',
	'errorSourcesTitle': 'No se ha podido cargar el árbol de datos',
	'errorLoadingDataSources': 'Se ha producido un error al cargar la lista de conjuntos de datos',
	'errorLoadingDataTree': 'Se ha producido un error al cargar el árbol',
	'dataSetPaneLastUpdated': 'Última actualización: %{date}',
	'dataSourcePaneDateUnknown': 'Desconocido',
	'moreTitle': 'Más',
	'backLabel': 'Retroceder',
	'addDataSourceDialogTitle': 'Seleccionar un origen',
	'addDataSourceDialogButtonLabel': 'Añadir',
	'dlg_use': 'Usar',
	'dlg_RelinkDataSourceTitle': 'Sustituir el conjunto de datos "%{dataSourceName}" por...',
	'propertiesDialogTitle': 'Propiedades',
	'loadingMetadata': 'Carga de metadatos',
	'missingDataSetData': 'Los datos para este conjunto de datos no están disponibles. Renueve el conjunto de datos o póngase en contacto con el administrador para acceder al origen.',
	'errorLoadingSource': 'Los metadatos de datos "%{sourceName}" no se han cargado. Póngase en contacto con el administrador para obtener información detallada.',
	'errorMessageTitle': 'Error',
	'calculation_navigation_in_use': 'Si se suprimen cálculos, filtros o vías de navegación se invalidan todas las visualizaciones que hacen referencia al elemento suprimido. ¿Está seguro de que desea suprimir?',
	'delete_confirm': 'Confirmar supresión',
	'previewUnavailable': 'La bandeja de datos y los filtros globales no están disponibles para este tipo de paquete.',
	'contextualGridTabName': 'Datos de visualización',
	'DATA_TRAY_no_data_text': 'Actualmente no tiene ningún dato',
	'contextualGridMenuLabel': 'Menú de datos de visualización',
	'contextualGridExport': 'Exportar',
	'nullValueText': 'Nulo',
	'forecastDetailsTabName': 'Detalles estadísticos de previsión',
	'forecastDetailsModelLabel': 'Modelo',
	'forecastDetailsQualityMetricLabel': 'Medidas de precisión',
	'forecastDetailsSmoothingCoefLabel': 'Parámetros',
	'forecastDetailsDiagnostics': 'Diagnósticos',
	'forecastDetailsForecastLabel': 'Predicción',
	'forecastDetailsStatusLabel': 'Estado',
	'forecastDetailsAccuracyPercentLabel': 'Precisión %',
	'forecastDetailsTrendLabel': 'Tendencia',
	'forecastDetailsSeasonLabel': 'Estacionalidad',
	'forecastDetailsSeasonalPeriodLabel': 'Periodo estacional',
	'forecastDetailsAlphaLabel': 'Alpha',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Falta recuento',
	'forecastDetailsSeriesLengthLabel': 'Longitud de series',
	'forecastDetailsIgnoredPeriods': 'Periodos ignorados',
	'forecastDetailsTrendStrength': 'Fuerza de tendencia',
	'forecastDetailsSeasonalityStrength': 'Fuerza de estacionalidad',
	'forecastDetailsTimeDeltaUnit': 'Intervalo de fecha/hora',
	'forecastDetailsNotes': 'Notas'
});
